import { ContactoConfiguracionReadingDtoProps } from "api/DTOs/ContactoConfiguracionReadingDto"
import { ContactoReadingDtoProps } from "api/DTOs/ContactoReadingDto"
import { EmpresaGetUsuarioLoggedDtoProps } from "api/DTOs/EmpresaGetUsuarioLoggedDto"
import { GetFacturaProformaByIdDtoProps } from "api/DTOs/GetFacturaProformaByIdDto"
import { GetFacturaProformaDetalleByIdDtoProps } from "api/DTOs/GetFacturaProformaDetalleByIdDto"
import { ImpuestoEmpresaReadingDtoProps } from "api/DTOs/ImpuestoEmpresaReadingDto"
import { TIPO_DOCUMENTO_COMERCIAL } from "api/Types/TipoDocumentoComercial"
import { MODES_DOCUMENTOS } from "features/Crear/pages/FormCreacionDocumento/constant"
import { FormasPago } from "features/Crear/pages/FormCreacionDocumento/hooks/ConvertirDocumento/ConvertirDocumento"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"

export const PROFORMA_DETAIL_MODAL_ENTRIES = (
  t: TFunction,
  clickedRowData?: GetFacturaProformaByIdDtoProps
) =>
  Object.entries({
    ...(clickedRowData?.numero
      ? {
          [t("nsProformaInvoices.modalDetail.documentNumber")]:
            clickedRowData.numero,
        }
      : {}),
    ...(clickedRowData?.razonSocial
      ? {
          [t("nsProformaInvoices.modalDetail.bussinessName")]:
            clickedRowData.razonSocial,
        }
      : {}),
    ...(clickedRowData?.fechaEmision
      ? {
          [t("nsProformaInvoices.modalDetail.issueDate")]: frontendDateFormat(
            new Date(clickedRowData.fechaEmision)
          ),
        }
      : {}),
    ...(clickedRowData?.importe
      ? {
          [t("nsProformaInvoices.modalDetail.amount")]: frontendCurrency(
            clickedRowData.importe
          ),
        }
      : {}),
  })

interface ProformaToConvertParams {
  id: string
  proforma: GetFacturaProformaDetalleByIdDtoProps
  librado: ContactoReadingDtoProps
  librador?: EmpresaGetUsuarioLoggedDtoProps
  libradoPreferences: ContactoConfiguracionReadingDtoProps
  formasPago: FormasPago[]
  tiposImpuestosGenerales: $TSMigrationFixMe
  t: TFunction
}

export const proformaToConvertObject = ({
  id,
  proforma,
  librado,
  librador,
  libradoPreferences,
  formasPago,
  tiposImpuestosGenerales,
  t,
}: ProformaToConvertParams) => ({
  facturaProformaId: id,
  tipoDocumentoComercial: TIPO_DOCUMENTO_COMERCIAL.VENTA,
  mode: MODES_DOCUMENTOS.VENTA,
  descuento: proforma.descuento || null,
  divisa: proforma.divisa,
  docAsociado: `${t(
    "newDoc.facturaProforma.invoiceLabel"
  )}: ${proforma.numero?.toUpperCase()}`,
  fechaEmision: proforma.fechaEmision,
  fechaVencimiento: proforma.fechaVencimiento,
  ficheroId: proforma.ficheroId,
  importe: proforma.importe,
  importeBruto: proforma.importeBruto,
  importeDescuento: proforma.importeDescuento,
  numero: proforma.numero,
  numeroDocumento: proforma.numeroDocumento,
  razonSocial: proforma.razonSocial,
  tarifaImpuesto: proforma.retencion?.porcentaje,
  librado,
  librador,
  articuloDocumentos: proforma.conceptos?.map((articulo) => ({
    articulo: {
      concepto: articulo?.nombre,
      precioVenta: articulo?.precio,
    },
    cantidad: articulo?.cantidad,
    impuestoArticuloPorcentaje: articulo?.impuesto?.porcentaje,
    tarifaImpuesto: articulo?.impuesto?.porcentaje,
  })),
  formaPago: libradoPreferences?.formaPago,
  diasPago: libradoPreferences?.diaDePago,
  config: {
    screen: 3,
    formasPago,
    tiposImpuestosRepercutidos: tiposImpuestosGenerales.filter(
      (tax: ImpuestoEmpresaReadingDtoProps) =>
        tax.tipo === 1 && tax?.grupoImpuesto?.tipoGrupoImpuesto === 0
    ),
  },
})
